<template>
    <section class="card-section">
        <div class="section-title">
            <h2>Itens avaliados</h2>
            <span>
                Avaliação por grupo e subgrupo com marcação C / CR / NC / NA e observações.
            </span>
        </div>

        <div
            v-for="secao in secoes"
            :key="secao.codigo"
            class="secao-box"
        >
            <div class="secao-header">
                <div>
                    <strong>{{ secao.codigo }}. {{ secao.titulo }}</strong>
                </div>
                <small>{{ secao.subgrupos.length }} subgrupo(s)</small>
            </div>

            <div
                v-for="subgrupo in secao.subgrupos"
                :key="subgrupo.codigo"
                class="subgrupo-box"
            >
                <div class="subgrupo-title">
                    {{ subgrupo.codigo }}. {{ subgrupo.titulo }}
                </div>

                <div class="table-wrapper">
                    <table class="itens-table">
                        <thead>
                            <tr>
                                <th class="col-codigo">Item</th>
                                <th>Descrição</th>
                                <th class="col-situacao">C</th>
                                <th class="col-situacao">CR</th>
                                <th class="col-situacao">NC</th>
                                <th class="col-situacao">NA</th>
                                <th class="col-obs-item">Obs. item</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr
                                v-for="item in subgrupo.itens"
                                :key="item.codigo"
                            >
                                <td class="col-codigo">{{ item.codigo }}</td>
                                <td>{{ item.descricao }}</td>

                                <td class="center">
                                    <input
                                        type="radio"
                                        :name="`item-${item.codigo}`"
                                        value="C"
                                        :checked="localItens[item.codigo]?.situacao === 'C'"
                                        @change="atualizarSituacao(item.codigo, 'C')"
                                    >
                                </td>

                                <td class="center">
                                    <input
                                        type="radio"
                                        :name="`item-${item.codigo}`"
                                        value="CR"
                                        :checked="localItens[item.codigo]?.situacao === 'CR'"
                                        @change="atualizarSituacao(item.codigo, 'CR')"
                                    >
                                </td>

                                <td class="center">
                                    <input
                                        type="radio"
                                        :name="`item-${item.codigo}`"
                                        value="NC"
                                        :checked="localItens[item.codigo]?.situacao === 'NC'"
                                        @change="atualizarSituacao(item.codigo, 'NC')"
                                    >
                                </td>

                                <td class="center">
                                    <input
                                        type="radio"
                                        :name="`item-${item.codigo}`"
                                        value="NA"
                                        :checked="localItens[item.codigo]?.situacao === 'NA'"
                                        @change="atualizarSituacao(item.codigo, 'NA')"
                                    >
                                </td>

                                <td>
                                    <input
                                        type="text"
                                        :value="localItens[item.codigo]?.observacao || ''"
                                        @input="atualizarObsItem(item.codigo, $event.target.value)"
                                        placeholder="Observação do item"
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="form-item mt-10">
                    <label>Observações do subgrupo {{ subgrupo.codigo }}</label>
                    <textarea
                        rows="3"
                        :value="localObservacoes[subgrupo.codigo] || ''"
                        @input="atualizarObsSubgrupo(subgrupo.codigo, $event.target.value)"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed } from 'vue'
import { supervisaoEstabelecimentoSecoes } from './inspecaoSupervisaoEstabelecimento_56B.js'

const props = defineProps({
    itens: {
        type: Object,
        required: true,
    },
    observacoes: {
        type: Object,
        required: true,
    },
})

const emit = defineEmits(['update:itens', 'update:observacoes'])

const secoes = supervisaoEstabelecimentoSecoes

const localItens = computed(() => props.itens)
const localObservacoes = computed(() => props.observacoes)

function atualizarSituacao(codigo, situacao) {
    emit('update:itens', {
        ...props.itens,
        [codigo]: {
            ...props.itens[codigo],
            situacao,
        },
    })
}

function atualizarObsItem(codigo, observacao) {
    emit('update:itens', {
        ...props.itens,
        [codigo]: {
            ...props.itens[codigo],
            observacao,
        },
    })
}

function atualizarObsSubgrupo(codigo, valor) {
    emit('update:observacoes', {
        ...props.observacoes,
        [codigo]: valor,
    })
}
</script>

<style scoped>
.card-section {
    background: #fff;
    border: 1px solid #d8dee8;
    border-radius: 10px;
    padding: 16px;
}

.section-title h2 {
    margin: 0;
    font-size: 18px;
    color: #1f2937;
}

.section-title span {
    display: block;
    margin-top: 4px;
    color: #6b7280;
    font-size: 13px;
}

.secao-box {
    margin-top: 18px;
    border: 1px solid #dbe2ea;
    border-radius: 10px;
    overflow: hidden;
}

.secao-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #eef2f7;
    padding: 12px 14px;
    color: #1f2937;
}

.subgrupo-box {
    padding: 14px;
    border-top: 1px solid #e5e7eb;
}

.subgrupo-title {
    font-weight: 700;
    color: #334155;
    margin-bottom: 10px;
}

.table-wrapper {
    overflow-x: auto;
}

.itens-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
}

.itens-table th,
.itens-table td {
    border: 1px solid #dbe2ea;
    padding: 8px;
    vertical-align: top;
}

.itens-table thead th {
    background: #f8fafc;
}

.col-codigo {
    width: 90px;
    white-space: nowrap;
}

.col-situacao {
    width: 52px;
    text-align: center;
}

.col-obs-item {
    width: 220px;
}

.center {
    text-align: center;
}

.form-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-item label {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
}

.form-item input,
.form-item textarea {
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 8px 10px;
    outline: none;
}

.mt-10 {
    margin-top: 10px;
}
</style>